import React from "react";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import PageWrapper from "./Tier.style";
import TierTable from "components/tier/TierTable";

const Tier = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.tier"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/tier"
          },
          {
            name: "sidebar.tier"
          }
        ]}
      />
      <div className="user-tbl">
        <TierTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.permissionReducer
  };
};

export default connect(mapStateToProps, null)(Tier);
